import loadView from "@/utils/load-view";

const routes = [
    // Legacy routes
    {
        path: "/profile/visit/:userId",
        redirect: "/profile/:userId",
    },
    {
        path: "/team/feedback/user/:userId",
        redirect: to => ({
            path: "/profile/:userId/feedback/create",
            query: {
                to: to.params.userId,
                requestedBy: to.params.userId,
            },
        }),
    },
    // Current routes
    {
        path: "/profile/:userId",
        name: "Profile",
        component: loadView("UserProfile"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [],
        },
        children: [
            {
                path: "/profile/:userId/team",
                name: "TeamDashboard",
                component: loadView("UserProfile"),
                props: true,
                meta: {
                    authRequired: true,
                },
            },
            {
                path: "/profile/:userId/feedback/request",
                name: "FeedbackRequestOnProfile",
                component: loadView("FeedbackRequest"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({ type: "skills/getSkills", payload: { showAll: false } }),
                        to => {
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
            {
                path: "/profile/:userId/feedback/create",
                name: "FeedbackCreateOnProfile",
                component: loadView("FeedbackCreate"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => {
                            // From feedback request
                            if (to.query.requestedBy) {
                                return {
                                    type: "skills/getListForUser",
                                    payload: { userId: to.query.requestedBy },
                                };
                            }

                            // From side menu
                            if (to.query.to) {
                                return {
                                    type: "skills/getListForUser",
                                    payload: { userId: to.query.to },
                                };
                            }
                        },
                        to => {
                            if (to.query.requestedBy) {
                                return {
                                    type: "feedback/request/get",
                                    payload: { senderId: to.query.requestedBy },
                                };
                            }
                        },
                        to => {
                            // From side menu
                            // Note that for feedback requests, the user's info is already returned by the API
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
            {
                path: "/profile/:userId/feedback/create/praise",
                name: "FeedbackCreatePraiseOnProfile",
                component: loadView("FeedbackCreatePraise"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({ type: "feedback/badges/getList" }),
                        to => {
                            if (to.query.to) {
                                return {
                                    type: "users/details/get",
                                    payload: { id: to.query.to },
                                };
                            }
                        },
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                    ],
                },
            },
            {
                path: "/profile/:userId/feedback/:id",
                name: "FeedbackDetailsOnProfile",
                component: loadView("FeedbackDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => ({
                            type: "feedback/feedback/getDetails",
                            payload: { id: to.params.id },
                        }),
                        to => ({
                            type: "feedback/feedback/read",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
            {
                path: "/profile/feedback/:id",
                name: "FeedbackDetailsOnProfileFallback",
                component: loadView("FeedbackDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => ({
                            type: "feedback/feedback/getDetails",
                            payload: { id: to.params.id },
                        }),
                        to => ({
                            type: "feedback/feedback/read",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
            {
                path: "/profile/:userId/skill-timeline/:skillId",
                name: "SkillTimelineOnProfile",
                component: loadView("UserProfileSkillTimeline"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [],
                },
            },
            {
                path: "/profile/:userId/edit",
                name: "ProfileEdit",
                component: loadView("UserProfileEdit"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [],
                },
            },
        ],
    },
    {
        path: "/profile",
        name: "ProfileOwner",
        component: loadView("UserProfile"),
        meta: {
            authRequired: true,
        },
    },
];

export default routes;
